import * as yup from 'yup';

import { AssetType } from '@blockpulse3/graphql/hooks';
import { requiredNumberField, requiredStringField } from '@blockpulse3/web-client/forms';

import { defaultHoldingMethodOptions } from '../../AllowedHoldingMethodSelect';
import { IPrivateFundraisingParametersForm } from './types';

export const privateSubscriptionPeriodOptions = [
  { label: '2 semaines', value: 14 },
  { label: '3 semaines', value: 21 },
  { label: '4 semaines', value: 28 },
  { label: '5 semaines', value: 35 },
  { label: '6 semaines', value: 42 },
];

export const schemaFundraisingPrivate = yup.object({
  name: requiredStringField,
  subscriptionPeriod: yup.object({
    label: requiredStringField,
    value: requiredNumberField,
  }),
  valuation: requiredNumberField,
  pricePerShare: requiredNumberField,
  assetType: requiredStringField,
});

export const privateParametersDefaultValues: IPrivateFundraisingParametersForm = {
  name: '',
  subscriptionPeriod: privateSubscriptionPeriodOptions[0],
  valuation: 0,
  pricePerShare: 0,
  assetType: AssetType.ORDINARY_SHARE,
  allowedHoldingMethods: defaultHoldingMethodOptions,
};
